import { getErrorAction } from './errorMapper'
import { NOT_FOUND, FORBIDDEN } from '../constants/httpStatusCodes'
import { NOT_FOUND_TYPES_PROJECT } from '../constants/notFoundTypes'
import { ERROR_MESSAGE_TYPE_BOARD_PERMSSIONS } from '../constants/errorMessageTypes'
import { redirectToNotFound } from './redirectToNotFound'
import { redirectToError } from './redirectToError'
import { createReducer } from './reducerUtils'
import { mergeMap, map, catchError } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { of } from 'rxjs'

// Actions
export const PROJECT_LOAD = 'PROJECT_LOAD'
export const PROJECT_LOAD_SUCCESS = 'PROJECT_LOAD_SUCCESS'
export const PROJECT_LOAD_FAILURE = 'PROJECT_LOAD_FAILURE'

// Action Creators
export const projectLoad = projectId => ({ type: PROJECT_LOAD, payload: projectId })
export const projectLoadSuccess = (project, ppmUrl) => ({
  type: PROJECT_LOAD_SUCCESS,
  payload: {
    ...project,
    url: `${ppmUrl}/workspace/applicationredirect.aspx?oid=${project.id}|9e91e194-1371-41a3-a278-cdbea91e0c1e&app=taskApp`
  }
})
export const projectLoadFailure = payload => ({ type: PROJECT_LOAD_FAILURE, payload, error: true })

// Epics
export const projectLoadEpic = (action$, state$, { vapiClient }) =>
  action$.pipe(
    ofType(PROJECT_LOAD),
    mergeMap(action =>
      vapiClient.getProject(action.payload).pipe(
        map(ajaxResponse => projectLoadSuccess(ajaxResponse.response, state$.value.config.ppmUrl)),
        catchError(error => of(getErrorAction(error, projectLoadFailure)))
      )
    )
)

export const projectLoadFailureEpic = (action$, state$) =>
  action$.pipe(
    ofType(PROJECT_LOAD_FAILURE),
    map(action => {
      switch (action.payload.status) {
        case NOT_FOUND:
          return redirectToNotFound(NOT_FOUND_TYPES_PROJECT)
        case FORBIDDEN:
          return redirectToError(ERROR_MESSAGE_TYPE_BOARD_PERMSSIONS)
        default:
          return redirectToError()
      }
    })
  )

// Reducer
const projectLoadSuccessReducer = (state, project) => ({
  id: project.id,
  name: project.title,
  url: project.url,
  actions: project.actions
})

const projectHandlerMapping = {
  [PROJECT_LOAD_SUCCESS]: projectLoadSuccessReducer
}

const projectInitialState = { actions: {} }
export const projectReducer = createReducer(projectInitialState, projectHandlerMapping)

export default projectReducer



// WEBPACK FOOTER //
// ./src/store/project.js